module.exports = __webpack_public_path__ + "static/media/bu3563-global-sat-2.8e4102ef.jpg";